// extracted by mini-css-extract-plugin
export var actions = "MobileHeader-module--actions--SuuBI";
export var content = "MobileHeader-module--content--ihOst";
export var expandCollapseLinks = "MobileHeader-module--expandCollapseLinks--RvLur";
export var expandableLink = "MobileHeader-module--expandableLink--CTNGG";
export var expandableLinkWithoutDescription = "MobileHeader-module--expandableLinkWithoutDescription--QFniQ";
export var fixedColor = "MobileHeader-module--fixedColor--qBmfr";
export var header = "MobileHeader-module--header--0n7b0";
export var headerButtons = "MobileHeader-module--headerButtons--EQ8E7";
export var headerContainer = "MobileHeader-module--headerContainer--dDrO4";
export var headerMenu = "MobileHeader-module--headerMenu--LyoxI";
export var isOpen = "MobileHeader-module--isOpen--FMdhp";
export var limitWidthOnLargeScreens = "MobileHeader-module--limitWidthOnLargeScreens--0Me+U";
export var openHeaderMenu = "MobileHeader-module--openHeaderMenu--XSxOp";
export var pricingLink = "MobileHeader-module--pricingLink--w0ExJ";
export var scrolled = "MobileHeader-module--scrolled--xldQ-";
export var title = "MobileHeader-module--title--AQR0u";
export var titleHasDescription = "MobileHeader-module--titleHasDescription--VgJa8";
export var titleHasTopics = "MobileHeader-module--titleHasTopics--694wW";